<div *ngIf="viewModel"
     class="patient-widget-container"
     [ngClass]="{'expanded': expanded}"
     #tcmVar="tcmVar"
     [tcmVar]="{isBalanceDisabled: salesOrderStatus && (salesOrderStatus == orderStatusEnum.Canceled || salesOrderStatus == orderStatusEnum.Voided 
        || salesOrderStatus == orderStatusEnum.NoSale || salesOrderStatus == orderStatusEnum.Returned || salesOrderStatus == orderStatusEnum.Exchanged)}">
    <div class="info-container">
        <div class="sections-wrapper">
            <div class="section photo">
                <div class="photo-wrapper">
                    <img class="patient-photo" src="{{viewModel.photo || '/assets/images/no-photo.jpg'}}" />
                    <div class="make-photo" *ngIf="canEdit">
                        <a href="#" oncontextmenu="return false;" (click)="openMakePhotoModal($event)">
                            {{'Screens.Patients.InfoWidget.Update' | translate}}
                        </a>
                    </div>
                </div>
            </div>
            <div class="section info">
                <div class="patient-info">
                  <div class="description">
                    <a routerLink="/patients/details" [queryParams]="{id: requestModel.patientId}" target="_blank">
                      <span class="name">{{ viewModel.fullName }}</span>
                    </a>
                    <div *ngIf="viewModel.dateOfBirth">
                      {{ viewModel.dateOfBirth | wafShortDate }} ({{viewModel.fullYears}})
                    </div>
                    <div *ngIf="viewModel.accountNumber">
                      Acct: {{viewModel.accountNumber}}
                    </div>
                    <div *ngIf="viewModel.insuranceCompany && viewModel.insurancePlanNotesFileId == null">
                      {{viewModel.insuranceCompany}}
                    </div>
                    <div *ngIf="viewModel.insuranceCompany && viewModel.insurancePlanNotesFileId != null"
                         class="file-link-preview"
                         (click)="onAttachmentClick(viewModel.insurancePlanNotesFileId)">
                      {{viewModel.insuranceCompany}}
                    </div>
                    <div *ngIf="viewModel.servicePlanName">
                      <div *ngIf="viewModel.servicePlanNotesFileId == null" class="inline-div">
                        {{viewModel.servicePlanName}}
                      </div>
                      <div *ngIf="viewModel.servicePlanNotesFileId != null"
                          class="inline-div file-link-preview"
                          (click)="onAttachmentClick(viewModel.servicePlanNotesFileId)">
                        {{viewModel.servicePlanName}}
                      </div>                      
                      <div class="inline-div expiration-wrapper">
                        <span>({{'Screens.Patients.InfoWidget.ExpirationDate' | translate}}: {{ viewModel.servicePlanExpirationDate | wafShortDate }})</span>                        
                      </div>
                    </div>
                    <div *ngIf="viewModel.status">
                      <span class="fw-bold">
                        {{'Common.SearchColumnsAndDetailsFields.Status' | translate}}:
                      </span>
                      <span [class.warning-caption]="viewModel.status == patientStatusEnum.Deceased">{{patientStatusTranslations[viewModel.status]}}</span>
                    </div>
                  </div>
                </div>
                <div class="patient-actions">
                    <div class="action-wrapper mb-3" *hasPermission="permissions.documents">
                        <button type="button" class="btn btn-complete"
                                [routerLink]="['/patients/files/list', {mode: 'modal', size: 'md'}]"
                                [queryParams]="{id: requestModel.patientId, patientActive: !patientInactive }">
                            {{'Screens.Patients.InfoWidget.PatientDocs' | translate}}
                        </button>
                    </div>
                    <div class="action-wrapper">
                        <button type="button" class="btn btn-complete" *ngIf="!patientInactive"
                                [routerLink]="['/patients/patient-alerts', {mode: 'modal', size: 'md'}]"
                                [queryParams]="{patientId: requestModel.patientId}">
                            {{'Screens.Patients.PatientAlerts.Search.Title' | translate }}
                            <span class="badge badge-success badge-out alerts-badge"
                                  *ngIf="viewModel.newAlertsCount">{{viewModel.newAlertsCount}}</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="sections-wrapper details-table">
          <div class="header-row">
            <div class="section-header">{{'Screens.Patients.InfoWidget.ClinicAndProvider' | translate}}</div>
            <div class="section-header">{{'Screens.Patients.InfoWidget.ContactInformation' | translate}}</div>
            <div class="section-header" *ngIf="viewModel.rightEquipmentData || viewModel.leftEquipmentData">
              {{'Screens.Patients.InfoWidget.PatientEquipment' | translate}}
              <button title="Swap" *ngIf="!patientInactive && specialActionPermissions.allowToUpdateLatestEquipmentOnPatient.canExecute"
                      class="btn btn-complete ms-1"
                      [routerLink]="['/patients/details/patient-equipment-widget-search', {mode: 'modal', size: 'lg'}]"
                      [queryParams]="{patientId: requestModel.patientId,productGroupId: null, status:null}">
                <i class="fa fa-exchange" aria-hidden="true"></i>
              </button>
            </div>
           
            <div class="section-header" *ngIf="viewModel.rightEquipmentData && viewModel.leftEquipmentData">
            </div>
            <ng-container *ngIf="canReadSalesOrder">
              <div *ngIf="salesOrderNumber"
                   class="section-header">
                {{'Screens.Patients.InfoWidget.Order' | translate}}:
                {{salesOrderNumber}}
              </div>
              <div *ngIf="viewModel.orderStatus && !salesOrderNumber"
                   class="section-header">{{'Screens.Patients.InfoWidget.OrderStatus' | translate}}</div>
            </ng-container>
          </div>
          <div class="description-row">
            <div class="description">
              <div *ngIf="viewModel.providerName">
                {{ viewModel.providerName }}
              </div>
              <div *ngIf="viewModel.clinicName">
                {{viewModel.clinicName}}
              </div>
              <div *ngIf="viewModel.lastVisitDate">
                {{'Screens.Patients.InfoWidget.LastVisit' | translate}}: {{viewModel.lastVisitType}},
                {{viewModel.lastVisitDate | wafShortDate}}
              </div>
              <div *ngIf="viewModel.lastEvalDate">
                <span class="fw-bold">{{'Screens.Patients.InfoWidget.LastEval' | translate}}:</span>
                {{viewModel.lastEvalDate | wafShortDate}} ({{viewModel.lastEvalDate | timeSpent}})
              </div>
            </div>
            <div class="description">
              <div *ngIf="viewModel.cellPhone || viewModel.homePhone">
                <span *ngIf="viewModel.cellPhone"
                      class="send-sms-item">
                  {{ viewModel.cellPhone }}
                  <em *ngIf="canEdit && viewModel.allowText"
                     (click)="createSmsMessageAsync()"
                     class="fa fa-envelope"></em>
                </span>
                <span *ngIf="viewModel.cellPhone && viewModel.homePhone" class="delimiter"> , </span>
                <span *ngIf="viewModel.homePhone">
                  {{ viewModel.homePhone }}
                </span>
              </div>
              <div *ngIf="viewModel.email">
                <a class="fw-bold clickable-text" (click)="createEmailMessageAsync(viewModel.email)">{{viewModel.email}}</a>
              </div>
              <div *ngIf="viewModel.companion">
                {{'Screens.Patients.InfoWidget.Companion' | translate}}: {{viewModel.companion}} <span class="info-icon"></span>
              </div>
            </div>

            <div class="description" *ngIf="viewModel.rightEquipmentData">

              <div>
                <span class="fw-bold">{{viewModel.rightEquipmentData.productOrientation}}</span> <span *ngIf="viewModel.rightEquipmentData.onTrial">({{serializedItemStatusTranslations[viewModel.rightEquipmentData.status]}})</span>

              </div>
              <div>
                <span class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.Product' | translate}}:</span>
                <span>
                  <a class="main-color-text" title="{{viewModel.rightEquipmentData.productStyleName}}" [routerLink]="['/patients/details/patient-equipment-details', {mode: 'modal', size: 'lg'}]"
                     [queryParams]="{id: viewModel.rightEquipmentData.id, isPatientReadonly: true}"> {{viewModel.rightEquipmentData.product}} </a>
                </span>
              </div>
              <div>
                <span class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.SerialNumber' | translate}}:</span>
                <span class="ms-1" title="{{viewModel.rightEquipmentData.serialNumber}}">{{viewModel.rightEquipmentData.serialNumber}}</span>
              </div>
              <div>
                <span class="fw-bold">{{'Screens.SerializedItems.Details.Fields.FittingDate'| translate}}:</span>
                <span class="ms-1" title="{{viewModel.rightEquipmentData.fittingDate}}">{{viewModel.rightEquipmentData.fittingDate}}</span>
              </div>              
              <div>
                <span class="fw-bold">{{'Screens.Products.Details.ProductStyles.Details.Fields.BatterySize' | translate}}:</span>
                <span class="ms-1">

                  <span>
                    <span *ngIf="viewModel.rightEquipmentData.batterySize!=null">
                      {{viewModel.rightEquipmentData.batterySize}}
                      <i class="fa fa-battery-quarter" aria-hidden="true"></i>
                    </span>
                    <span *ngIf="viewModel.rightEquipmentData.batterySize==null">
                      {{'Screens.Patients.InfoWidget.NotAvailable' | translate}}
                      <i class="fa fa-battery-empty" aria-hidden="true"></i>
                    </span>
                  </span>
                </span>
              </div>
              <div>
                <span class="fw-bold">{{'Screens.SerializedItems.Details.Fields.WarrantyExpirationDate'| translate}}:</span>
                <span class="ms-1" [class.text-danger]="rightSideWarrantyExpirationInactive" title="{{viewModel.rightEquipmentData.warrantyExpirationDate}}">{{viewModel.rightEquipmentData.warrantyExpirationDate}}</span>
              </div>
            </div>
            <div class="description" *ngIf="viewModel.leftEquipmentData">
              <span class="fw-bold">{{viewModel.leftEquipmentData.productOrientation}}</span> <span *ngIf="viewModel.leftEquipmentData.onTrial">({{serializedItemStatusTranslations[viewModel.leftEquipmentData.status]}})</span>
              <div>
                <span class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.Product' | translate}}: </span>
                <a class="main-color-text" title="{{viewModel.leftEquipmentData.productStyleName}}" [routerLink]="['/patients/details/patient-equipment-details', {mode: 'modal', size: 'lg'}]"
                   [queryParams]="{id: viewModel.leftEquipmentData.id, isPatientReadonly: true}"> {{viewModel.leftEquipmentData.product}} </a>
              </div>
              <div>
                <span class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.SerialNumber' | translate}}:</span>
                <span class="ms-1">{{viewModel.leftEquipmentData.serialNumber}}</span>
              </div>
              <div>
                <span class="fw-bold">{{'Screens.SerializedItems.Details.Fields.FittingDate'| translate}}:</span>
                <span class="ms-1" title="{{viewModel.leftEquipmentData.fittingDate}}">{{viewModel.leftEquipmentData.fittingDate}}</span>
              </div>              
              <div>
                <span class="fw-bold">{{'Screens.Products.Details.ProductStyles.Details.Fields.BatterySize' | translate}}:</span>
                <span class="ms-1" >
                  <span>
                    <span *ngIf="viewModel.leftEquipmentData.batterySize!=null">
                      {{viewModel.leftEquipmentData.batterySize}}
                      <i class="fa fa-battery-quarter" aria-hidden="true"></i>
                    </span>
                    <span *ngIf="viewModel.leftEquipmentData.batterySize==null">
                      {{'Screens.Patients.InfoWidget.NotAvailable' | translate}}
                      <i class="fa fa-battery-empty" aria-hidden="true"></i>
                    </span>
                  </span>
                </span>

              </div>
              <div>
                <span class="fw-bold">{{'Screens.SerializedItems.Details.Fields.WarrantyExpirationDate'| translate}}:</span>
                <span class="ms-1" [class.text-danger]="leftSideWarrantyExpirationInactive" title="{{viewModel.leftEquipmentData.warrantyExpirationDate}}">{{viewModel.leftEquipmentData.warrantyExpirationDate}}</span>
              </div>
            </div>
            <div class="description" *ngIf="canReadSalesOrder">
              <div *ngIf="salesOrderStatus">
                <span
                      class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.Status' | translate}}:</span>
                {{orderStatusTranslations[salesOrderStatus]}}
                <field-history-button class="ms-2"
                                      *ngIf="salesOrderId && specialActionPermissions.allowToShowFieldHistory.canExecute"
                                      typeOfValue="enum"
                                      displayNameKey="Common.SearchColumnsAndDetailsFields.Status"
                                      [entity]="historyHelper.entity.SalesOrder"
                                      [entityId]="salesOrderId"
                                      [entityField]="historyHelper.fields.salesOrder.Status"
                                      [enumTranslationKey]="historyHelper.enumTranslationKey.OrderStatusEnum">
                </field-history-button>
              </div>
              <div *ngIf="!salesOrderStatus && viewModel.orderStatus">
                <span
                      class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.Status' | translate}}:</span>
                {{orderStatusTranslations[viewModel.orderStatus]}}
              </div>
              <div *ngIf="salesOrderId && (salesOrderTotalPatientPart || salesOrderTotalPatientPart === 0)">
                <span
                      class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.TotalPatientPart' | translate}}:</span>
                <span class="ms-1">{{salesOrderTotalPatientPart | wafCurrency }}</span>
              </div>
              <div *ngIf="!salesOrderId && viewModel.totalPatientPart">
                <span
                      class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.TotalPatientPart' | translate}}:</span>
                <span class="ms-1">{{viewModel.totalPatientPart | wafCurrency }}</span>
              </div>
              <div *ngIf="salesOrderId && (salesOrderPatientBalance || salesOrderPatientBalance === 0)">
                <span
                      class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.PatientBalance' | translate}}:</span>
                <span *ngIf="!tcmVar.var.isBalanceDisabled"
                      class="ms-1">{{salesOrderPatientBalance | wafCurrency }}</span>
                <span *ngIf="tcmVar.var.isBalanceDisabled"
                      class="ms-1">{{orderStatusTranslations[salesOrderStatus]}}</span>
              </div>
              <div *ngIf="!salesOrderId && viewModel.totalPatientBalance">
                <span
                      class="fw-bold">{{'Common.SearchColumnsAndDetailsFields.PatientBalance' | translate}}:</span>
                <span class="ms-1">{{viewModel.totalPatientBalance | wafCurrency }}</span>
              </div>
              <div *ngIf="invoiceNumber">
                <span
                      class="fw-bold">{{'Screens.Patients.InfoWidget.InvoiceNumber' | translate}}:</span>
                {{invoiceNumber}}
                <span *ngIf="isFinanced">({{'Screens.Patients.InfoWidget.Financed' | translate}})</span>
              </div>
            </div>
          </div>
          </div>
    </div>
    <div class="recent-activity" *ngIf="expanded">
        <div class="row expansion-header">
            <div class="col-md-8 expansion-title fw-bold">
                Patient Status and Recent Activity
            </div>
            <div class="col-md-4">
                <a *ngIf="canEditNotes && !patientInactive" [routerLink]="['/patients/details/note-details', {mode: 'modal', size: 'lg'}]"
                   [queryParams]="newNoteRequestModel">
                    <em class="fa fa-plus"></em> {{'Common.SearchColumnsAndDetailsFields.Note' | translate}}
                </a>
                <a class="view-journal-link" href (click)="openPatientJournal($event)">
                    {{'Screens.Patients.InfoWidget.ViewPatientJournal' | translate}} >
                </a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-8">
                <noah-short-info [requestModel]="requestModel"></noah-short-info>
            </div>
            <div class="col-md-4">
                <patient-journal [requestModel]="{ patientId: requestModel.patientId, paging: { pageSize: 4 } }"
                                 [isPreview]="true"></patient-journal>
            </div>
        </div>
    </div>
    <div class="expand" (click)="toggleExpand()">
        <img src="/assets/images/icons/ico-circle-open.svg" class="ico-circle-open" [class.ico-circle-close]="expanded" />        
    </div>
</div>
